import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { onLimitExceeded } from '../../services/HttpService';
import UpgradeModal from './UpgradeModal';

const PaywallContext = createContext({ openUpgrade: () => {} });

/**
 * Open the upgrade modal imperatively from any component, e.g.
 *   const { openUpgrade } = useUpgrade();
 *   <Button onClick={() => openUpgrade()}>Upgrade</Button>
 */
export const useUpgrade = () => useContext(PaywallContext);

/**
 * Mounts once near the app root. Subscribes to HttpService's limit-exceeded
 * event so ANY write blocked by a resource limit (403 LIMIT_EXCEEDED) surfaces
 * the upgrade modal, and exposes openUpgrade() for explicit CTAs.
 */
export default function PaywallProvider({ children }) {
  const [state, setState] = useState({ open: false, details: null });

  const openUpgrade = useCallback((details = null) => {
    setState({ open: true, details });
  }, []);

  const close = useCallback(() => {
    setState({ open: false, details: null });
  }, []);

  useEffect(() => {
    // onLimitExceeded returns an unsubscribe function.
    return onLimitExceeded((details) => openUpgrade(details));
  }, [openUpgrade]);

  return (
    <PaywallContext.Provider value={{ openUpgrade }}>
      {children}
      <UpgradeModal isOpen={state.open} details={state.details} onClose={close} />
    </PaywallContext.Provider>
  );
}
